import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useId, useState } from "react";
import { addDays, format, formatISO, parse, parseISO, subDays } from "date-fns";
import { ru } from "date-fns/locale";
import { ruRU } from "@mui/x-date-pickers/locales";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Popover from "@mui/material/Popover";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import classnames from "classnames";
import { CALENDAR_MAX_DATE, CALENDAR_MIN_DATE } from "../../services/calendar/index.js";
import { useCalendar } from "../../services/hooks/index.js";
import { Typography } from "../../Typography/index.js";
import { Box } from "../../Box/index.js";
import { Icon } from "../../Icon/index.js";
import { Label, Preloader } from "../common/index.js";
import { toDate } from "../../format/index.js";
import ReactInputMask from "../../ReactInputMask/index.js";
import { CalendarHeader } from "./CalendarHeader.js";
import { Day } from "./Day.js";
import { useStyles } from "./DateInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function DateInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else DateInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const DATE_FORMAT = 'dd.MM.yyyy';
const EMPTY_INPUT_MASK = '__.__.____';
const DateInput = (t0)=>{
    const $ = c(246);
    let customCalendarDownload;
    let error;
    let externalError;
    let formBlur;
    let id;
    let isRecognitionUsedBefore;
    let label;
    let labelIcon;
    let name;
    let onBlur;
    let onChange;
    let onClear;
    let onLogAction;
    let otherSelectedDate;
    let recognizedValue;
    let renderDayFooter;
    let renderDayTooltip;
    let rest;
    let shouldDisableDate;
    let t1;
    let t10;
    let t11;
    let t12;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let value;
    let warning;
    let warnings;
    if ($[0] !== t0) {
        ({ label, labelIcon, name, onChange, formBlur, onClear, onLogAction, placeholder: t1, required: t2, disablePast: t3, disabled: t4, minDate: t5, maxDate: t6, recognizedValue, isRecognitionUsedBefore, shouldDisableDate, externalError, otherSelectedDate, clearable: t7, alwaysShowClear: t8, error, warning, warnings, value, onBlur, loading: t9, showRange: t10, tooltip: t11, testId: t12, id, renderDayTooltip, renderDayFooter, customCalendarDownload } = t0), rest = _object_without_properties(t0, [
            "label",
            "labelIcon",
            "name",
            "onChange",
            "formBlur",
            "onClear",
            "onLogAction",
            "placeholder",
            "required",
            "disablePast",
            "disabled",
            "minDate",
            "maxDate",
            "recognizedValue",
            "isRecognitionUsedBefore",
            "shouldDisableDate",
            "externalError",
            "otherSelectedDate",
            "clearable",
            "alwaysShowClear",
            "error",
            "warning",
            "warnings",
            "value",
            "onBlur",
            "loading",
            "showRange",
            "tooltip",
            "testId",
            "id",
            "renderDayTooltip",
            "renderDayFooter",
            "customCalendarDownload"
        ]);
        $[0] = t0;
        $[1] = customCalendarDownload;
        $[2] = error;
        $[3] = externalError;
        $[4] = formBlur;
        $[5] = id;
        $[6] = isRecognitionUsedBefore;
        $[7] = label;
        $[8] = labelIcon;
        $[9] = name;
        $[10] = onBlur;
        $[11] = onChange;
        $[12] = onClear;
        $[13] = onLogAction;
        $[14] = otherSelectedDate;
        $[15] = recognizedValue;
        $[16] = renderDayFooter;
        $[17] = renderDayTooltip;
        $[18] = rest;
        $[19] = shouldDisableDate;
        $[20] = t1;
        $[21] = t10;
        $[22] = t11;
        $[23] = t12;
        $[24] = t2;
        $[25] = t3;
        $[26] = t4;
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
        $[32] = value;
        $[33] = warning;
        $[34] = warnings;
    } else {
        customCalendarDownload = $[1];
        error = $[2];
        externalError = $[3];
        formBlur = $[4];
        id = $[5];
        isRecognitionUsedBefore = $[6];
        label = $[7];
        labelIcon = $[8];
        name = $[9];
        onBlur = $[10];
        onChange = $[11];
        onClear = $[12];
        onLogAction = $[13];
        otherSelectedDate = $[14];
        recognizedValue = $[15];
        renderDayFooter = $[16];
        renderDayTooltip = $[17];
        rest = $[18];
        shouldDisableDate = $[19];
        t1 = $[20];
        t10 = $[21];
        t11 = $[22];
        t12 = $[23];
        t2 = $[24];
        t3 = $[25];
        t4 = $[26];
        t5 = $[27];
        t6 = $[28];
        t7 = $[29];
        t8 = $[30];
        t9 = $[31];
        value = $[32];
        warning = $[33];
        warnings = $[34];
    }
    const placeholder = void 0 === t1 ? "\u0414\u0414.\u041C\u041C.\u0413\u0413\u0413\u0413" : t1;
    const required = void 0 === t2 ? false : t2;
    const disablePast = void 0 === t3 ? false : t3;
    const disabled = void 0 === t4 ? false : t4;
    const minDate = void 0 === t5 ? CALENDAR_MIN_DATE : t5;
    const maxDate = void 0 === t6 ? CALENDAR_MAX_DATE : t6;
    const clearable = void 0 === t7 ? false : t7;
    const alwaysShowClear = void 0 === t8 ? false : t8;
    const loading = void 0 === t9 ? false : t9;
    const showRange = void 0 === t10 ? false : t10;
    const tooltip = void 0 === t11 ? null : t11;
    const testId = void 0 === t12 ? "test-id-date-input-text-field" : t12;
    const { classes } = useStyles();
    const reactId = useId();
    const inputId = null != id ? id : reactId;
    const calendar = useCalendar();
    let t13;
    if ($[35] !== value) {
        t13 = value ? parseISO(value) : null;
        $[35] = value;
        $[36] = t13;
    } else t13 = $[36];
    const valueAsDate = t13;
    let t14;
    if ($[37] !== value) {
        t14 = value ? format(new Date(value), DATE_FORMAT, {
            locale: ru
        }) : "";
        $[37] = value;
        $[38] = t14;
    } else t14 = $[38];
    const [inputValue, setInputValue] = useState(t14);
    const [errorByShouldDisableDate, setErrorByShouldDisableDate] = useState(false);
    const [errorText, setErrorText] = useState(error);
    const [loaded, setLoaded] = useState(false);
    const [showClear, setShowClear] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [hoverDate, setHoverDate] = useState(null);
    const open = Boolean(anchorEl);
    let t15;
    if ($[39] !== maxDate) {
        t15 = ()=>{
            if (!maxDate) return "";
            if (maxDate instanceof Date) return addDays(maxDate, 1);
            return maxDate;
        };
        $[39] = maxDate;
        $[40] = t15;
    } else t15 = $[40];
    const getMaxDateText = t15;
    let t16;
    if ($[41] !== calendar || $[42] !== getMaxDateText || $[43] !== maxDate || $[44] !== minDate || $[45] !== shouldDisableDate) {
        t16 = (date)=>{
            if (!date) return;
            if (!calendar.isValidDate(date)) return "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0434\u0430\u0442\u0430";
            if (calendar.startOfDay(new Date(minDate)) > calendar.startOfDay(date)) return `Дата должна быть больше чем ${toDate(subDays(new Date(minDate), 1).toString())}`;
            if (calendar.startOfDay(new Date(maxDate)) < calendar.startOfDay(date)) return `Дата должна быть меньше чем ${toDate(getMaxDateText().toString())}`;
            setErrorByShouldDisableDate(!!(null == shouldDisableDate ? void 0 : shouldDisableDate(date)));
        };
        $[41] = calendar;
        $[42] = getMaxDateText;
        $[43] = maxDate;
        $[44] = minDate;
        $[45] = shouldDisableDate;
        $[46] = t16;
    } else t16 = $[46];
    const getErrorText = t16;
    let t17;
    if ($[47] !== calendar || $[48] !== customCalendarDownload || $[49] !== error || $[50] !== formBlur || $[51] !== getErrorText || $[52] !== name || $[53] !== onChange || $[54] !== onLogAction || $[55] !== value) {
        t17 = (event)=>{
            setLoaded(false);
            const newValue = event.target.value;
            setInputValue(newValue);
            if (!newValue || newValue === EMPTY_INPUT_MASK) {
                onChange(void 0);
                null == formBlur || formBlur(name);
                setLoaded(true);
                return;
            }
            const newValueAsDate = parse(newValue, DATE_FORMAT, new Date());
            if (newValueAsDate instanceof Date && !isNaN(newValueAsDate.valueOf())) if (customCalendarDownload) customCalendarDownload(newValueAsDate);
            else calendar.download(newValueAsDate);
            const errorMessage = getErrorText(newValueAsDate);
            if (errorMessage) {
                if (value) onChange(void 0);
                setErrorText(errorMessage);
            } else {
                const newValueIso = formatISO(newValueAsDate, {
                    representation: "date"
                });
                null == onLogAction || onLogAction("\u0412\u0432\u0435\u0434\u0435\u043D\u0430 \u0434\u0430\u0442\u0430");
                onChange(newValueIso);
                setErrorText(error);
            }
            null == formBlur || formBlur(name);
            setLoaded(true);
        };
        $[47] = calendar;
        $[48] = customCalendarDownload;
        $[49] = error;
        $[50] = formBlur;
        $[51] = getErrorText;
        $[52] = name;
        $[53] = onChange;
        $[54] = onLogAction;
        $[55] = value;
        $[56] = t17;
    } else t17 = $[56];
    const handleInputChange = t17;
    let t18;
    if ($[57] !== calendar || $[58] !== error || $[59] !== errorText || $[60] !== formBlur || $[61] !== inputValue || $[62] !== name || $[63] !== onChange || $[64] !== value || $[65] !== valueAsDate) {
        t18 = ()=>{
            if (calendar.isValidDate(valueAsDate) && !errorText) {
                const newValueIso_0 = valueAsDate ? formatISO(new Date(valueAsDate), {
                    representation: "date"
                }) : void 0;
                onChange(newValueIso_0);
                null == formBlur || formBlur(name);
                return;
            }
            if (value && !error) {
                const oldValueAsDate = new Date(value);
                setInputValue(format(oldValueAsDate, "dd.MM.yyyy", {
                    locale: ru
                }));
            } else {
                setInputValue("");
                if (value) onChange(void 0);
            }
            null == formBlur || formBlur(name);
            setErrorText(inputValue !== EMPTY_INPUT_MASK ? null != errorText ? errorText : error : error);
        };
        $[57] = calendar;
        $[58] = error;
        $[59] = errorText;
        $[60] = formBlur;
        $[61] = inputValue;
        $[62] = name;
        $[63] = onChange;
        $[64] = value;
        $[65] = valueAsDate;
        $[66] = t18;
    } else t18 = $[66];
    const handleInputBlur = t18;
    let t19;
    let t20;
    if ($[67] !== value) {
        t19 = ()=>{
            if (value) {
                const asDate = new Date(value);
                setInputValue(format(asDate, DATE_FORMAT, {
                    locale: ru
                }));
            } else setInputValue("");
        };
        t20 = [
            value
        ];
        $[67] = value;
        $[68] = t19;
        $[69] = t20;
    } else {
        t19 = $[68];
        t20 = $[69];
    }
    useEffect(t19, t20);
    let t21;
    let t22;
    if ($[70] !== error || $[71] !== errorByShouldDisableDate || $[72] !== onChange) {
        t21 = ()=>{
            if (error && "force" !== errorByShouldDisableDate) return void setErrorText(error);
            if (errorByShouldDisableDate) {
                setErrorByShouldDisableDate("force");
                setErrorText("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0434\u0430\u0442\u0430");
                onChange(void 0);
            } else setErrorText(void 0);
        };
        t22 = [
            error,
            errorByShouldDisableDate,
            onChange
        ];
        $[70] = error;
        $[71] = errorByShouldDisableDate;
        $[72] = onChange;
        $[73] = t21;
        $[74] = t22;
    } else {
        t21 = $[73];
        t22 = $[74];
    }
    useEffect(t21, t22);
    let t23;
    let t24;
    if ($[75] !== formBlur || $[76] !== name || $[77] !== onChange || $[78] !== recognizedValue || $[79] !== value) {
        t23 = ()=>{
            if (recognizedValue && !value) {
                onChange(recognizedValue);
                null == formBlur || formBlur(name);
            }
        };
        t24 = [
            onChange,
            name,
            formBlur,
            recognizedValue,
            value
        ];
        $[75] = formBlur;
        $[76] = name;
        $[77] = onChange;
        $[78] = recognizedValue;
        $[79] = value;
        $[80] = t23;
        $[81] = t24;
    } else {
        t23 = $[80];
        t24 = $[81];
    }
    useEffect(t23, t24);
    let t25;
    if ($[82] !== disabled || $[83] !== isRecognitionUsedBefore || $[84] !== onBlur || $[85] !== recognizedValue) {
        t25 = ()=>{
            if (onBlur && isRecognitionUsedBefore && !disabled && !recognizedValue) onBlur();
        };
        $[82] = disabled;
        $[83] = isRecognitionUsedBefore;
        $[84] = onBlur;
        $[85] = recognizedValue;
        $[86] = t25;
    } else t25 = $[86];
    let t26;
    if ($[87] !== disabled || $[88] !== isRecognitionUsedBefore || $[89] !== onBlur) {
        t26 = [
            isRecognitionUsedBefore,
            disabled,
            onBlur
        ];
        $[87] = disabled;
        $[88] = isRecognitionUsedBefore;
        $[89] = onBlur;
        $[90] = t26;
    } else t26 = $[90];
    useEffect(t25, t26);
    let t27;
    let t28;
    if ($[91] !== calendar || $[92] !== customCalendarDownload) {
        t27 = ()=>{
            if (customCalendarDownload) customCalendarDownload(new Date()).then(()=>setLoaded(true));
            else calendar.download(new Date()).then(()=>setLoaded(true));
        };
        t28 = [
            calendar,
            customCalendarDownload
        ];
        $[91] = calendar;
        $[92] = customCalendarDownload;
        $[93] = t27;
        $[94] = t28;
    } else {
        t27 = $[93];
        t28 = $[94];
    }
    useEffect(t27, t28);
    let t29;
    if ($[95] !== error || $[96] !== formBlur || $[97] !== name || $[98] !== onBlur || $[99] !== onChange || $[100] !== onClear) {
        t29 = (e)=>{
            e.preventDefault();
            setInputValue("");
            setLoaded(false);
            setShowClear(false);
            setAnchorEl(null);
            setErrorText(error);
            setErrorByShouldDisableDate(false);
            onChange(void 0);
            null == formBlur || formBlur(name);
            null == onBlur || onBlur();
            null == onClear || onClear();
            setTimeout(()=>setLoaded(true), 500);
        };
        $[95] = error;
        $[96] = formBlur;
        $[97] = name;
        $[98] = onBlur;
        $[99] = onChange;
        $[100] = onClear;
        $[101] = t29;
    } else t29 = $[101];
    const clearDateInput = t29;
    let t30;
    if ($[102] !== disabled || $[103] !== loaded || $[104] !== onLogAction) {
        t30 = (e_0)=>{
            e_0.stopPropagation();
            if (loaded && !disabled) {
                null == onLogAction || onLogAction("\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C");
                setAnchorEl(e_0.currentTarget);
            }
        };
        $[102] = disabled;
        $[103] = loaded;
        $[104] = onLogAction;
        $[105] = t30;
    } else t30 = $[105];
    const dateIconClickHandler = t30;
    const isLoading = !loaded || loading;
    const getCalendarIconColor = _temp;
    let t31;
    if ($[106] !== calendar || $[107] !== classes.clearIcon || $[108] !== clearDateInput || $[109] !== clearable || $[110] !== dateIconClickHandler || $[111] !== isLoading || $[112] !== loaded) {
        t31 = (props)=>{
            if (isLoading) return /*#__PURE__*/ jsx(Preloader, {});
            const propsValueAsDate = parse(props.value, DATE_FORMAT, new Date());
            return /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                children: [
                    clearable && calendar.isValidDate(propsValueAsDate) && !props.disabled && /*#__PURE__*/ jsx(Box, {
                        display: "flex",
                        alignItems: "center",
                        className: classes.clearIcon,
                        mr: "12",
                        height: 24,
                        onClick: clearDateInput,
                        children: /*#__PURE__*/ jsx(Icon, {
                            name: "dismiss_substract",
                            size: "24",
                            color: props.error ? "accent.text.error" : "stroke.secondary"
                        })
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        onClick: (e_1)=>{
                            e_1.stopPropagation();
                            if (loaded && !props.disabled) setAnchorEl(e_1.currentTarget);
                        },
                        children: /*#__PURE__*/ jsx(Box, {
                            onClick: dateIconClickHandler,
                            display: "flex",
                            alignItems: "center",
                            children: /*#__PURE__*/ jsx(Icon, {
                                name: "calendar_outline",
                                size: "24",
                                color: getCalendarIconColor(props.disabled, !!props.error)
                            })
                        })
                    })
                ]
            });
        };
        $[106] = calendar;
        $[107] = classes.clearIcon;
        $[108] = clearDateInput;
        $[109] = clearable;
        $[110] = dateIconClickHandler;
        $[111] = isLoading;
        $[112] = loaded;
        $[113] = t31;
    } else t31 = $[113];
    const renderEndAdornment = t31;
    let t32;
    if ($[114] !== classes.input) {
        t32 = classnames(classes.input, "aqa_date_input");
        $[114] = classes.input;
        $[115] = t32;
    } else t32 = $[115];
    let t33;
    if ($[116] !== inputId || $[117] !== label || $[118] !== labelIcon || $[119] !== required || $[120] !== tooltip) {
        t33 = label && /*#__PURE__*/ jsx(Label, {
            label: label,
            required: required,
            tooltip: tooltip,
            icon: labelIcon,
            inputId: inputId
        });
        $[116] = inputId;
        $[117] = label;
        $[118] = labelIcon;
        $[119] = required;
        $[120] = tooltip;
        $[121] = t33;
    } else t33 = $[121];
    const t34 = isLoading ? "" : "99.99.9999";
    const t35 = isLoading ? "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." : inputValue;
    const t36 = isLoading || disabled;
    let t37;
    if ($[122] !== classes.textDateInput) {
        t37 = {
            root: classes.textDateInput
        };
        $[122] = classes.textDateInput;
        $[123] = t37;
    } else t37 = $[123];
    const t38 = placeholder || label;
    const t39 = isLoading || disabled;
    let t40;
    if ($[124] !== errorText || $[125] !== externalError) {
        t40 = errorText && {
            error: !!externalError || !!errorText,
            helperText: externalError || errorText
        };
        $[124] = errorText;
        $[125] = externalError;
        $[126] = t40;
    } else t40 = $[126];
    let t41;
    if ($[127] !== isLoading) {
        t41 = isLoading && {
            value: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
        };
        $[127] = isLoading;
        $[128] = t41;
    } else t41 = $[128];
    let t42;
    if ($[129] !== classes.adornedEnd) {
        t42 = {
            adornedEnd: classes.adornedEnd
        };
        $[129] = classes.adornedEnd;
        $[130] = t42;
    } else t42 = $[130];
    const t43 = !!errorText;
    let t44;
    if ($[131] !== disabled || $[132] !== inputValue || $[133] !== renderEndAdornment || $[134] !== t43) {
        t44 = renderEndAdornment({
            value: inputValue,
            disabled,
            error: t43
        });
        $[131] = disabled;
        $[132] = inputValue;
        $[133] = renderEndAdornment;
        $[134] = t43;
        $[135] = t44;
    } else t44 = $[135];
    let t45;
    if ($[136] !== placeholder || $[137] !== t42 || $[138] !== t44) {
        t45 = {
            input: {
                placeholder,
                className: "textFieldInput aqa_dt_input",
                classes: t42,
                endAdornment: t44
            }
        };
        $[136] = placeholder;
        $[137] = t42;
        $[138] = t44;
        $[139] = t45;
    } else t45 = $[139];
    let t46;
    if ($[140] !== inputId || $[141] !== name || $[142] !== t37 || $[143] !== t38 || $[144] !== t39 || $[145] !== t40 || $[146] !== t41 || $[147] !== t45) {
        t46 = /*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({
            id: inputId,
            classes: t37,
            variant: "outlined",
            name: name,
            fullWidth: true,
            placeholder: t38,
            disabled: t39
        }, t40, t41), {
            slotProps: t45
        }));
        $[140] = inputId;
        $[141] = name;
        $[142] = t37;
        $[143] = t38;
        $[144] = t39;
        $[145] = t40;
        $[146] = t41;
        $[147] = t45;
        $[148] = t46;
    } else t46 = $[148];
    let t47;
    if ($[149] !== handleInputBlur || $[150] !== handleInputChange || $[151] !== t34 || $[152] !== t35 || $[153] !== t36 || $[154] !== t46 || $[155] !== testId) {
        t47 = /*#__PURE__*/ jsx(ReactInputMask, {
            mask: t34,
            value: t35,
            "data-testid": testId,
            alwaysShowMask: false,
            disabled: t36,
            onBlur: handleInputBlur,
            onChange: handleInputChange,
            children: t46
        });
        $[149] = handleInputBlur;
        $[150] = handleInputChange;
        $[151] = t34;
        $[152] = t35;
        $[153] = t36;
        $[154] = t46;
        $[155] = testId;
        $[156] = t47;
    } else t47 = $[156];
    let t48;
    if ($[157] !== errorText || $[158] !== externalError || $[159] !== warning) {
        t48 = !externalError && !errorText && warning && /*#__PURE__*/ jsx(Typography, {
            variant: "caption",
            color: "text.light.secondary",
            children: warning
        });
        $[157] = errorText;
        $[158] = externalError;
        $[159] = warning;
        $[160] = t48;
    } else t48 = $[160];
    let t49;
    if ($[161] !== errorText || $[162] !== externalError || $[163] !== warnings) {
        t49 = !externalError && !errorText && warnings && warnings.length > 0 && /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexDirection: "column",
            gap: "4",
            children: warnings.map(_temp2)
        });
        $[161] = errorText;
        $[162] = externalError;
        $[163] = warnings;
        $[164] = t49;
    } else t49 = $[164];
    let t50;
    if ($[165] !== t47 || $[166] !== t48 || $[167] !== t49) {
        t50 = /*#__PURE__*/ jsxs(Box, {
            children: [
                t47,
                t48,
                t49
            ]
        });
        $[165] = t47;
        $[166] = t48;
        $[167] = t49;
        $[168] = t50;
    } else t50 = $[168];
    let t51;
    if ($[169] !== onBlur) {
        t51 = ()=>{
            setAnchorEl(null);
            null == onBlur || onBlur();
        };
        $[169] = onBlur;
        $[170] = t51;
    } else t51 = $[170];
    let t52;
    let t53;
    if ($[171] === Symbol.for("react.memo_cache_sentinel")) {
        t52 = {
            vertical: "bottom",
            horizontal: "center"
        };
        t53 = {
            vertical: "top",
            horizontal: "center"
        };
        $[171] = t52;
        $[172] = t53;
    } else {
        t52 = $[171];
        t53 = $[172];
    }
    let t54;
    if ($[173] !== calendar || $[174] !== customCalendarDownload) {
        t54 = customCalendarDownload ? customCalendarDownload : (date_0)=>calendar.download(date_0 || void 0);
        $[173] = calendar;
        $[174] = customCalendarDownload;
        $[175] = t54;
    } else t54 = $[175];
    let t55;
    if ($[176] !== error || $[177] !== onBlur || $[178] !== onChange || $[179] !== onLogAction) {
        t55 = (date_1, isFinal)=>{
            if (isFinal) {
                null == onLogAction || onLogAction("\u0412\u044B\u0431\u0440\u0430\u043D\u0430 \u0434\u0430\u0442\u0430");
                onChange(date_1 ? formatISO(date_1, {
                    representation: "date"
                }) : void 0);
                setErrorText(error);
                setErrorByShouldDisableDate(false);
                setAnchorEl(null);
                null == onBlur || onBlur();
                setTimeout(()=>setShowClear(true), 200);
            }
        };
        $[176] = error;
        $[177] = onBlur;
        $[178] = onChange;
        $[179] = onLogAction;
        $[180] = t55;
    } else t55 = $[180];
    let t56;
    if ($[181] !== shouldDisableDate) {
        t56 = shouldDisableDate ? {
            shouldDisableDate
        } : {};
        $[181] = shouldDisableDate;
        $[182] = t56;
    } else t56 = $[182];
    let t57;
    let t58;
    if ($[183] === Symbol.for("react.memo_cache_sentinel")) {
        t57 = {
            calendarHeader: CalendarHeader,
            day: Day
        };
        t58 = (_, day_0)=>{
            setHoverDate(day_0);
        };
        $[183] = t57;
        $[184] = t58;
    } else {
        t57 = $[183];
        t58 = $[184];
    }
    let t59;
    if ($[185] !== calendar || $[186] !== hoverDate) {
        t59 = (__0, day_1)=>{
            if (day_1 && hoverDate && calendar.isSameDay(day_1, hoverDate)) setHoverDate(null);
        };
        $[185] = calendar;
        $[186] = hoverDate;
        $[187] = t59;
    } else t59 = $[187];
    let t60;
    if ($[188] !== calendar) {
        t60 = (day_2)=>!calendar.isSameDay(day_2, new Date()) && calendar.isHolidayOrWeekend(day_2);
        $[188] = calendar;
        $[189] = t60;
    } else t60 = $[189];
    let t61;
    if ($[190] !== calendar || $[191] !== hoverDate || $[192] !== otherSelectedDate || $[193] !== showRange || $[194] !== valueAsDate) {
        t61 = (day_3)=>{
            if (hoverDate || valueAsDate) {
                const date_2 = hoverDate || valueAsDate;
                return !!(showRange && day_3 && otherSelectedDate && calendar.startOfDay(new Date(otherSelectedDate)) <= day_3 && calendar.startOfDay(new Date(date_2)) >= day_3);
            }
            return false;
        };
        $[190] = calendar;
        $[191] = hoverDate;
        $[192] = otherSelectedDate;
        $[193] = showRange;
        $[194] = valueAsDate;
        $[195] = t61;
    } else t61 = $[195];
    let t62;
    if ($[196] !== calendar || $[197] !== otherSelectedDate) {
        t62 = (day_4)=>!!(otherSelectedDate && day_4 && calendar.isSameDay(day_4, new Date(otherSelectedDate)));
        $[196] = calendar;
        $[197] = otherSelectedDate;
        $[198] = t62;
    } else t62 = $[198];
    let t63;
    if ($[199] !== calendar || $[200] !== hoverDate || $[201] !== otherSelectedDate || $[202] !== valueAsDate) {
        t63 = (day_5)=>{
            if (valueAsDate && calendar.isSameDay(day_5, new Date(valueAsDate)) || otherSelectedDate && calendar.isSameDay(day_5, new Date(otherSelectedDate))) return valueAsDate && !hoverDate && calendar.isSameDay(day_5, new Date(valueAsDate));
            return hoverDate && calendar.isSameDay(day_5, hoverDate);
        };
        $[199] = calendar;
        $[200] = hoverDate;
        $[201] = otherSelectedDate;
        $[202] = valueAsDate;
        $[203] = t63;
    } else t63 = $[203];
    let t64;
    if ($[204] !== renderDayFooter || $[205] !== renderDayTooltip || $[206] !== t59 || $[207] !== t60 || $[208] !== t61 || $[209] !== t62 || $[210] !== t63) {
        t64 = {
            onMouseEnter: t58,
            onMouseLeave: t59,
            testHoliday: t60,
            testIsInRange: t61,
            testIsStart: t62,
            testIsEnd: t63,
            renderDayTooltip,
            renderDayFooter
        };
        $[204] = renderDayFooter;
        $[205] = renderDayTooltip;
        $[206] = t59;
        $[207] = t60;
        $[208] = t61;
        $[209] = t62;
        $[210] = t63;
        $[211] = t64;
    } else t64 = $[211];
    const t65 = t64;
    let t66;
    if ($[212] !== t65) {
        t66 = {
            day: t65
        };
        $[212] = t65;
        $[213] = t66;
    } else t66 = $[213];
    let t67;
    if ($[214] !== disablePast || $[215] !== maxDate || $[216] !== minDate || $[217] !== rest || $[218] !== t54 || $[219] !== t55 || $[220] !== t56 || $[221] !== t66 || $[222] !== valueAsDate) {
        t67 = /*#__PURE__*/ jsx(DateCalendar, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, rest), {
            view: "day",
            dayOfWeekFormatter: _temp3,
            value: valueAsDate,
            onMonthChange: t54,
            disablePast: disablePast,
            minDate: minDate,
            maxDate: maxDate,
            onChange: t55
        }), t56), {
            slots: t57,
            slotProps: t66
        }));
        $[214] = disablePast;
        $[215] = maxDate;
        $[216] = minDate;
        $[217] = rest;
        $[218] = t54;
        $[219] = t55;
        $[220] = t56;
        $[221] = t66;
        $[222] = valueAsDate;
        $[223] = t67;
    } else t67 = $[223];
    let t68;
    if ($[224] !== alwaysShowClear || $[225] !== classes.action || $[226] !== clearDateInput || $[227] !== clearable || $[228] !== showClear || $[229] !== value) {
        t68 = clearable && value && (alwaysShowClear || showClear) && /*#__PURE__*/ jsx(Box, {
            pt: "16",
            px: "16",
            onClick: clearDateInput,
            children: /*#__PURE__*/ jsx("a", {
                href: "#",
                className: classes.action,
                children: "Сбросить"
            })
        });
        $[224] = alwaysShowClear;
        $[225] = classes.action;
        $[226] = clearDateInput;
        $[227] = clearable;
        $[228] = showClear;
        $[229] = value;
        $[230] = t68;
    } else t68 = $[230];
    let t69;
    if ($[231] !== t67 || $[232] !== t68) {
        t69 = /*#__PURE__*/ jsxs(Box, {
            className: "aqa_calendar",
            pb: "16",
            children: [
                t67,
                t68
            ]
        });
        $[231] = t67;
        $[232] = t68;
        $[233] = t69;
    } else t69 = $[233];
    let t70;
    if ($[234] !== anchorEl || $[235] !== open || $[236] !== t51 || $[237] !== t69) {
        t70 = /*#__PURE__*/ jsx(Popover, {
            open: open,
            anchorEl: anchorEl,
            onClose: t51,
            anchorOrigin: t52,
            transformOrigin: t53,
            children: t69
        });
        $[234] = anchorEl;
        $[235] = open;
        $[236] = t51;
        $[237] = t69;
        $[238] = t70;
    } else t70 = $[238];
    let t71;
    if ($[239] !== t33 || $[240] !== t50 || $[241] !== t70) {
        t71 = /*#__PURE__*/ jsxs(LocalizationProvider, {
            dateAdapter: AdapterDateFns,
            adapterLocale: ru,
            localeText: ruRU.components.MuiLocalizationProvider.defaultProps.localeText,
            children: [
                t33,
                t50,
                t70
            ]
        });
        $[239] = t33;
        $[240] = t50;
        $[241] = t70;
        $[242] = t71;
    } else t71 = $[242];
    let t72;
    if ($[243] !== t32 || $[244] !== t71) {
        t72 = /*#__PURE__*/ jsx(FormControl, {
            className: t32,
            children: t71
        });
        $[243] = t32;
        $[244] = t71;
        $[245] = t72;
    } else t72 = $[245];
    return t72;
};
function _temp(isDisabled, isError) {
    if (isDisabled) return "stroke.secondary";
    if (isError) return "accent.text.error";
    return "original.brand.primary";
}
function _temp2(warningText, index) {
    return /*#__PURE__*/ jsx(Typography, {
        variant: "caption",
        color: "text.light.secondary",
        children: warningText
    }, index);
}
function _temp3(day) {
    return format(new Date(day), "EEEEEE", {
        locale: ru
    });
}
export { DateInput };
